import React, { useEffect, useState } from 'react';
import {
  Container,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import './popup.css';
function Popup(props) {
  const [paginationIndex, setPaginationIndex] = useState(0);
  let imagesArray = props.images;
  const [mainImg, setMainImg] = useState(props?.images[0]?.image);
  const [videosrc, setVideoSrc] = useState(props?.videos ? props?.videos[0] : []);
  const [pkgs, setPkgs] = useState([]);
  useEffect(() => {
    setMainImg(props?.images[0]?.image);
    setVideoSrc(props?.videos ? props?.videos[0] : []);
  }, [props])
  function scroll(spcl) {
    var doc = document.getElementById("pd_img_list_box_cntn_id");
    if (spcl === "l") {
      if(paginationIndex - 1 < 0){
        setPaginationIndex(0);
        setMainImg(imagesArray[0].image);
        return;
      }
      setPaginationIndex(paginationIndex - 1);
      setMainImg(imagesArray[paginationIndex - 1].image);
      doc.scrollLeft -= 50;
    } else {
      if(paginationIndex + 1 >= imagesArray.length){
        setPaginationIndex(imagesArray.length - 1);
        setMainImg(imagesArray[imagesArray.length - 1].image);
        return;
      } 
      setPaginationIndex(paginationIndex + 1);
      setMainImg(imagesArray[paginationIndex + 1].image);
      doc.scrollLeft += 50;
    }
  }
  useEffect(() => {
    let propPkgs = [];
    if (props?.pkgs && props?.pkgs.length > 0) {
      for (const pkg of props?.pkgs) {
        if (pkg.status == "APPROVED") {
          pkg["packageWidthFront"] = (pkg.packageWidth / 30.48).toFixed(2);
          pkg["packageHeightFront"] = (pkg.packageHeight / 30.48).toFixed(2);
          pkg["packageLengthFront"] = (pkg.packageLength / 30.48).toFixed(2);
          propPkgs.push(pkg);
        }
      }
    }
    setPkgs(propPkgs);
  }, [props.pkgs]);
  function changeImage(item, index) {
    setMainImg(item?.image);
    setPaginationIndex(index);
  }
  function checkMinusInput(e) {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  }

  function showPkgEdit() {
    const nextPkgs = [...pkgs];
    nextPkgs.map((pkg, index) => {
      pkg.pkgEdit = !pkg.pkgEdit;
    });
    setPkgs(nextPkgs);
  }
  const handlePkgChange = () => { }
  return (
    <>
      <div className={`popup popup-detail${props.fixedImage ? " popup-detail-fixed-image" : ""}`} key={props.id}>
        <div className="oM-c">
          <div className='header-pop'>
            <div className="header-title">Product</div>
            <a className="close-pop" onClick={() => props.popupVisibility()}>&times;</a>
          </div>

          <Container className='scroll-y'>
            <div class="d-flex f-d-column popup-detail-split">

              <div className='col-md-4 col-sm-12 col-xs-12 popup-detail-image-col'>
                {/* <Carousel className="contain-Carousel">
                  {imagesArray && imagesArray.map((item, index) => {
                    if (item.image.startsWith("products")) {
                      return (
                        <Carousel.Item key={index}>
                          <img
                            id={index}
                            className="d-block w-100 img-size"
                            // src={props.from === "manualProducts" ? "https://s3.toolsvilla.com/mob/"+item.image : "https://s3.toolsvilla.com/" +item.image}
                            src={"https://s3.toolsvilla.com/" +item.image}
                            alt={item.image}
                          />

                        </Carousel.Item>
                      )
                    }
                    else if (item.image.startsWith("mob")) {
                      return (
                        <Carousel.Item key={index}>
                          <img
                            id={index}
                            className="d-block w-100 img-size"
                            src={props.from === "manualProducts" ? "https://s3.toolsvilla.com/mob/"+item.image : "https://s3.toolsvilla.com/" +item.image}
                            alt={item.image}
                          />

                        </Carousel.Item>
                      )
                    }
                    else {
                      var img = item.image.substr("41")
                      return (
                        <Carousel.Item key={index}>
                          <img
                            id={index}
                            className="d-block w-100 img-size"
                            src={"https://s3.toolsvilla.com/" + img}
                            alt={item.image}
                          />

                        </Carousel.Item>
                      )
                    }
                  }
                  )}
                </Carousel> */}
                <div className="container">
                  <div className="pd_img_main_box">
                    {imagesArray && imagesArray.length > 0 ? (
                      <><img
                        src={props.from === "manualProducts" ? "https://s3.toolsvilla.com/mob/" + mainImg : "https://s3.toolsvilla.com/" + mainImg}
                        className=""
                        alt="img" />
                        <div className="pagination-dot-container">
                          {imagesArray.map((item, index) => {
                            return <div onClick={() => { changeImage(item, index) }} className={`pagination-dot ${paginationIndex == index ? "active" : ""}`}></div>;

                          })}
                        </div></>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="image-thumbnail-slider my-4">
                    {imagesArray && imagesArray.length > 3 ? (

                      <img src="/left-slide-icon.webp" className="slider-icon" alt="icon" onClick={() => scroll("l")} />
                    ) : (
                      <></>
                    )}
                    <div
                      className="pd_img_list_box_cntn"
                      id="pd_img_list_box_cntn_id"
                    >
                      {imagesArray.map((item, index) => {

                        return (
                          <div
                            className={`pd_img_list_box ${paginationIndex == index ? "active" : ""}`}
                            role="button"
                            onClick={() => { changeImage(item, index) }}
                          >
                            <img
                              className=""
                              src={
                                "https://s3.toolsvilla.com/" + item.image
                              }
                              alt="Product Img"
                            />
                          </div>
                        );
                      })}
                    </div>
                    {imagesArray && imagesArray.length > 3 ? (

                      <img src="/right-slide-icon.webp" className="slider-icon" alt="icon" onClick={() => scroll("r")} />
                    ) : (
                      <></>
                    )}
                  </div>
                  {/* Videos */}
                  {/* videosrc, setVideoSrc */}
                  {props?.videos && props?.videos.length > 0 ?
                    <>
                      <div className="pd_video_main_box mt-3">
                        {videosrc?.includes("products") ?
                          <video
                            controls
                            className=""
                            src={"https://media.toolsvilla.com/" + videosrc}
                            alt="Product Img"
                          />
                          :
                          <iframe
                            width="100%"
                            height="400"
                            src={`https://www.youtube.com/embed/${videosrc}`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        }
                      </div>

                    </> : ""
                  }
                   <div className="image-thumbnail-slider my-4">
                  {props?.videos && props?.videos.length > 0 ?
                    <div className="pd_img_list_box_cntn">
                      {
                        props?.videos.map((item, index) => {
                          const isProductVideo = item?.startsWith("products/");

                          return (
                            <div
                              key={index}
                              onClick={() => setVideoSrc(item)}
                              className={`pd_img_list_box ${props?.videos.indexOf(videosrc) == index ? "active" : ""}`}
                            >
                              {
                                isProductVideo ? (
                                  <video
                                  width="100%"
                                  height="100%"
                                    muted
                                    preload="metadata"
                                    playsInline
                                    src={`https://media.toolsvilla.com/${item}`}
                                  />
                                ) : (
                                  <img
                                    src={`https://img.youtube.com/vi/${item}/mqdefault.jpg`}
                                    alt="video thumbnail"
                                  />
                                )
                              }
                            </div>
                          );
                        })
                      }
                    </div> : <></>
                  }
                  </div>
                </div>
              </div>
              <div className='col-md-8 col-sm-12 col-xs-12 detail-new popup-detail-content-col'>
                <h6 className="pd_pName">{props.name}</h6>
                {props.SKU ? <h6 className="sku-data">SKU : {props.SKU}</h6> : <></>}

                <h6 className="pd_pName">{props?.manufacturerName}</h6>
                <ul className="d-flex ord-crd mb-0">
                  {props?.curCombinationValues && props?.curCombinationValues.length > 0 ? props?.curCombinationValues[0]?.value.map((item, index) => {
                    return (
                      <>
                        <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop" key={index}>{props?.curCombinationKeys[index]} - {item}</li>
                      </>
                    )
                  }) : <></>}

                </ul>
                <div>

                  {!props?.hideTransferPrice && (
                    props.from === "categories"
                      ? (props.price === null ? <></> : <div className="transfer_price">Transfer Price to Toolsvilla(incl. GST) : <span><i className="fa fa-inr" aria-hidden="true"></i> {props.price}</span>  </div>)
                      : (!props.price || props.price === undefined || props.price === null ? <></> : <div className="transfer_price">Transfer Price to Toolsvilla(incl. GST) : <span><i className="fa fa-inr" aria-hidden="true"></i> {props.price}</span>  </div>)
                  )}
                    


                </div>
                <div className="bottom-border"></div>
                {pkgs && pkgs.length > 0 ?
                  <>
                    <div className="">
                      <div className="prod-pkg-details">
                        <div className="title">Package Details</div>
                        {/* { state.pVend.sellerWeightChangeSts === "T_PENDING" ?
                      <span className="text-danger">Your requested weight is pending for verification from Toolsvilla</span>
                    : */}
                        <div className={`prod-pkg-details-container prod-pkg-details-container-bg`}>
                          <table className="table new-table-design">
                            <tr>
                              <th>Package Count</th>
                              <th>Package name</th>
                              <th>Actual Product<br /> Weight <strong>(Kg)</strong></th>
                              <th>After Packaging<br /> Weight <strong>(Kg)</strong></th>
                              <th>Package Dimension<br /><strong>L * B * H (Ft)</strong> </th>
                              <th>Volumetric Weight
                                <OverlayTrigger
                                  key={""}
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`tooltip-weight`} className="order_page_tooltip">
                                      <p className='f-500 fs-14 order_page_tooltip_1'>(L*B*H)/5000</p>
                                    </Tooltip>
                                  }
                                >
                                  <i class="bi bi-info-circle ms-1 bg-transparent"></i>
                                </OverlayTrigger>
                                <br /><strong>(Kg)</strong>
                              </th>
                            </tr>
                            {pkgs.map((item, index) => {
                              return (

                                <tr>
                                  <td>Package {index + 1}</td>
                                  <td><strong>{item.productName}</strong></td>
                                  <td className={`edit-pkg ${item.pkgEdit ? 'p-0' : ''}`}>
                                    {item.pkgEdit ? (
                                      <>
                                        <span>
                                          <input
                                            type="number"
                                            placeholder="Enter Weight"
                                            value={item.actualWeight}
                                            onKeyDown={checkMinusInput}
                                            onChange={(e) =>
                                              handlePkgChange(
                                                item._id,
                                                "actualWeight",
                                                e.target.value
                                              )
                                            }
                                            className="pkgInpt text-center"
                                          />
                                          {" Kg"}
                                        </span>
                                        {item.pkgEdit && item.actualWeight > 0 ? (
                                          ""
                                        ) : (
                                          <>
                                            <div class="toastAlert bg-transparent p-0 ms-1">
                                              {" "}
                                              Please enter a valid weight.
                                            </div>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <strong>{item.actualWeight}</strong>
                                    )}
                                  </td>
                                  <td className={`edit-pkg ${item.pkgEdit ? 'p-0' : ''}`}>
                                    {/* {item.weight} */}
                                    {item.pkgEdit ? (
                                      <>
                                        <span>
                                          <input
                                            type="number"
                                            placeholder="Enter Weight"
                                            value={item.weight}
                                            onKeyDown={checkMinusInput}
                                            onChange={(e) =>
                                              handlePkgChange(
                                                item._id,
                                                "weight",
                                                e.target.value
                                              )
                                            }
                                            className="pkgInpt text-center"
                                          />
                                          {" Kg"}
                                        </span>
                                        {item.pkgEdit && item.weight > 0 ? (
                                          ""
                                        ) : (
                                          <>
                                            <div class="toastAlert bg-transparent p-0 ms-1">
                                              {" "}
                                              Please enter a valid weight.
                                            </div>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <span>{item.weight}</span>
                                    )}
                                  </td>
                                  <td className={item.pkgEdit ? `p-0` : ``}>
                                    {item.pkgEdit ? (
                                      <>
                                        <div className={`edit-pkg bg-transparent ${item.pkgEdit ? 'p-0' : ''}`}>
                                          <span>
                                            <input
                                              type="number"
                                              placeholder="Length"
                                              value={item.packageLengthFront}
                                              onKeyDown={checkMinusInput}
                                              // maxlength="4"
                                              onChange={(e) =>
                                                handlePkgChange(
                                                  item._id,
                                                  "packageLength",
                                                  e.target.value
                                                )
                                              }
                                              className="dimInpt text-center"
                                            />
                                            <span> x</span>
                                            <input
                                              type="number"
                                              value={item.packageWidthFront}
                                              placeholder="Width"
                                              onKeyDown={checkMinusInput}
                                              // maxlength="4"
                                              onChange={(e) =>
                                                handlePkgChange(
                                                  item._id,
                                                  "packageWidth",
                                                  e.target.value
                                                )
                                              }
                                              className="dimInpt text-center"
                                            />
                                            <span> x</span>
                                            <input
                                              type="number"
                                              value={item.packageHeightFront}
                                              onKeyDown={checkMinusInput}
                                              placeholder="Height"
                                              // maxlength="4"
                                              onChange={(e) =>
                                                handlePkgChange(
                                                  item._id,
                                                  "packageHeight",
                                                  e.target.value
                                                )
                                              }
                                              className="dimInpt text-center"
                                            />
                                            {" Ft"}
                                          </span>
                                        </div>
                                        <>
                                          {item.pkgEdit &&
                                            item.packageHeight > 0 &&
                                            item.packageWidth > 0 &&
                                            item.packageLength > 0 ? (
                                            ""
                                          ) : (
                                            <>
                                              <div class="toastAlert bg-transparent p-0 ms-1">
                                                {" "}
                                                Please enter a valid dimension(Height, Weicht,
                                                Length).
                                              </div>
                                            </>
                                          )}
                                        </>
                                      </>
                                    ) : (
                                      <span className="bg-transparent">
                                        {(item.packageLength / 30.48).toFixed(2)}{", "}
                                        {(item.packageWidth / 30.48).toFixed(2)}{", "}
                                        {(item.packageHeight / 30.48).toFixed(2)}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {item.pkgEdit ? (
                                      <strong>{item.vWeight}</strong>
                                    ) : (
                                      <strong>{item?.vWeight?.toFixed(2)}</strong>
                                    )}
                                  </td>
                                </tr>
                              )
                            })}
                          </table>
                          {/* {props?.pVend?.sellerWeightChangeSts === "V_PENDING" && 
                        <div className="bottom-action text-center">
                          <div className="title">! Weight and dimension verification request from Toolsvilla.
                          <span>Do you want to accept it ?</span></div>
                          { !showWeightSubmitBtn ? (
                          <div className="action-button">
                              <button
                                className="no-button"
                                // onClick={() =>
                                //   updateSellerWeightChangeSts(
                                //     selectedId,
                                //     "V_REJECT"
                                //   )
                                // }
                                onClick={(e) => {showPkgEdit(); setShowWeightSubmitBtn(true)}}
                              >
                                No
                              </button>
                              <button
                                className="yes-button"
                                onClick={() =>
                                  updateSellerWeightChangeSts(
                                    selectedId,
                                    "V_ACTIVE"
                                  )
                                }
                              >
                                yes
                              </button>
                          </div>
                          ) : (
                            <div className="action-button">
                              <button
                                className="yes-button"
                                onClick={() =>
                                  saveSellerWeightChange()
                                }
                              >
                                Submit
                              </button>
                            </div>
                          )}
                        </div>
                      } */}
                        </div>
                        {/* } */}
                      </div>
                      {/* <h6 className="shipping-title">Shipping</h6> */}

                      {/* <div className="shipNtWrap">
                    {pkgs.map((item, index) => {
                      return (
                        <>
                          <div className="packages-title">
                            Package {index + 1} ({item.productName})
                          </div>
                          <Row className="">
                            <div className="col-6">
                              <span>Product Weight:</span>
                              <span> {item.actualWeight}kg</span>
                            </div>
                            <div className="col-6">
                              <span>Volumetric Weight:</span>
                              <span> {item.vWeight.toFixed(2)}kg</span>
                            </div>
                            <div className="col-12">
                              <span>After packaging:</span>
                              <span> {item.weight}kg</span>
                            </div>
                            <div className="col-12">
                              <span>Dimensions: </span>
                              <span>
                                {(item.packageLength / 30.48).toFixed(2)}L x{" "}
                                {(item.packageWidth / 30.48).toFixed(2)}W x{" "}
                                {(item.packageHeight / 30.48).toFixed(2)}H Ft
                              </span>
                            </div>
                          </Row>
                        </>
                      );
                    })}
                    {state.pVend.sellerWeightChangeSts === "V_PENDING" && (
                      <div className="confirmation-title">
                        <p>
                          Weight and dimension verification request from
                          toolsvilla
                        </p>
                        <div className="accept-grid">
                          <div>Do you want to accept it ?</div>
                          <div className="col-6">
                            <button
                              className="yes-button"
                              onClick={() =>
                                updateSellerWeightChangeSts(
                                  selectedId,
                                  "V_ACTIVE"
                                )
                              }
                            >
                              Yes
                            </button>
                          </div>
                          <div className="col-6">
                            <button
                              className="no-button"
                              onClick={() =>
                                updateSellerWeightChangeSts(
                                  selectedId,
                                  "V_REJECT"
                                )
                              }
                            >
                              No
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div> */}

                      {/* <div className="vnote">
                    {state.pVend.sellerWeightChangeSts === "V_PENDING" ||
                    state.pVend.sellerWeightChangeSts === "V_ACTIVE" ? (
                      <p className="btmNote">
                        <strong>Note - </strong>All the shipments are checked at our courier
                        warehouse and if in case the product weight & dimensions
                        are found different than that given by the logistics
                        company Toolsvilla would debit the seller for the
                        difference. We therefore request you to be careful when
                        entering the weight & dimensions. Thank you!
                      </p>
                    ) : <></>
                    // : state.pVend.sellerWeightChangeSts !== "T_PENDING" && (
                    //   state.pVend.sellerWeightChangeSts !== "T_ACTIVE" ? 
                    //   ( <p className="btmNote text-center">
                    //     { state.pVend.sellerWeightChangeSts === "T_REJECT" ? (
                    //       <span>Your requested Shipping details has been Rejected by Toolsvilla on{" "}</span>
                    //     ): state.pVend.sellerWeightChangeSts === "V_REJECT" && (
                    //       <span>You have rejected the request from Toolsvilla on{" "}</span>
                    //     )}
                    //     { state && state.pVend &&
                    //       state.pVend.sellerWeightChangeDate != undefined &&
                    //     `${new Date(state.pVend.sellerWeightChangeDate)
                    //       .getDate()
                    //       .toString()
                    //       .padStart(2, "0")}-${monthAbbreviations[
                    //       new Date(
                    //         state.pVend.sellerWeightChangeDate
                    //       ).getMonth()
                    //     ]
                    //       .toString()
                    //       .padStart(2, "0")}-${new Date(
                    //       state.pVend.sellerWeightChangeDate
                    //     ).getFullYear()}`}
                    //   </p>
                    //   ) : (
                    //     <span>Your weight request is approved </span>
                    //   )
                    // )
                    }
                    { pkgs && pkgs.length > 0 && pkgs[0].lockStatus && (
                      <span>This Sku's weight details are locked</span>
                    )}
                  </div> */}
                    </div>
                    <div className="bottom-border"></div>
                  </> : (
                    <></>
                  )}
                {/* <h6 className="text-danger">Product Details</h6> */}
                <div className="pd_desc">
                  <div className="pd_long_desc">Product Details</div>
                  <div className='pd_description'>
                    <div id="popupDescription" dangerouslySetInnerHTML={{ __html: props.description }}>

                    </div>
                  </div>
                </div>
                <div>

                  {/* </> : <></>} */}
                </div>
                {props?.descriptionNew && props?.descriptionNew.map((item, index) => {
                  return <><div class="title fs-13 mt-2 bold">{item?.title} : </div><div
                    className="desc fs-13"
                    dangerouslySetInnerHTML={{
                      __html: item.description,
                    }} />
                    {item?.title == 'Specification' && props?.specificationNew && props?.specificationNew.length > 0 &&
                      props?.specificationNew && props?.specificationNew.map((item, index) => {
                        return <><div
                          className="desc fs-14"
                        >
                          <ul className='mb-0'>
                            <li>
                              {item?.type?.name} : {item?.name}{" "}{item?.unit}
                            </li>
                          </ul>
                        </div></>
                      })
                    }
                  </>
                })}
                {!(props?.descriptionNew || []).some(obj => obj.title === "Specifications" || obj.title === "Specification") && props?.specificationNew && props?.specificationNew != "[]" && props?.specificationNew.length > 0 && <>
                  <div>
                    <div class="title fs-14 mb-1 mt-2 bold">Specifications : </div>
                    {props?.specificationNew && props?.specificationNew != "[]" && props?.specificationNew.map((item, index) => {
                      return <><div
                        className="desc fs-14"
                      >
                        <ul className='mb-0'>
                          <li>
                            {item?.type?.name} : {item?.name}{" "}{item?.unit}
                          </li>
                        </ul>
                      </div></>
                    })}
                  </div></>}
                <div className="pd_desc">
                  <div className="pd_long_desc">Short description</div>
                  <div className='pd_description'>
                    <div id="popupSpecification " dangerouslySetInnerHTML={{ __html: props.sdescription }}>
                    </div>
                  </div>
                </div>
                {/* {props.callback && props.lead ?
    <div className="d-grid gap-2">
      <br></br>
    <Button variant="secondary" size="sm" onClick={()=>props.callback(props.lead)}>
    Update Stock
    </Button>
    </div>:<></>} */}
              </div>
            </div>
          </Container>
        </div>
      </div>
    </>
  )
}

export default Popup;